import { HttpMethod, initFetch } from "../../utils/fetcher";
import {
  adaptedToTypeLot,
  typeLotsToAdapted,
  typeLotToAdapted,
} from "../../adapter/typeLotAdapter";

export const LOAD_TYPES_LOTS = "LOAD_TYPES_LOTS";
export const LOAD_SUCCESS_TYPES_LOTS = "LOAD_SUCCESS_TYPES_LOTS";
export const LOAD_FAIL_TYPES_LOTS = "LOAD_FAIL_TYPES_LOTS";
export const SAVE_SUCCESS_TYPES_LOTS = "SAVE_SUCCESS_TYPES_LOTS";
export const SAVE_FAIL_TYPES_LOTS = "SAVE_FAIL_TYPES_LOTS";
export const UPDATE_SUCCESS_TYPES_LOTS = "UPDATE_SUCCESS_TYPES_LOTS";
export const UPDATE_FAIL_TYPES_LOTS = "UPDATE_FAIL_TYPES_LOTS";
export const DELETE_SUCCESS_TYPES_LOTS = "DELETE_SUCCESS_TYPES_LOTS";
export const DELETE_FAIL_TYPES_LOTS = "DELETE_FAIL_TYPES_LOTS";

export function loadTypesLots() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`typesLots`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.type_lot);
          dispatch({
            type: LOAD_SUCCESS_TYPES_LOTS,
            payload: typeLotsToAdapted(res.type_lot),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_TYPES_LOTS,
            error: err,
          });
        });
    });
  };
}

export function saveTypeLot(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`typesLots`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToTypeLot(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.type_lot);
          dispatch({
            type: SAVE_SUCCESS_TYPES_LOTS,
            payload: typeLotToAdapted(res.type_lot),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_TYPES_LOTS,
            error: err,
          })
        );
    });
  };
}

export function updateTypeLot(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`typesLots/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToTypeLot(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.type_lot);
          dispatch({
            type: UPDATE_SUCCESS_TYPES_LOTS,
            payload: typeLotToAdapted(res.type_lot),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_TYPES_LOTS,
            error: err,
          })
        );
    });
  };
}

export function deleteTypeLot(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`typesLots/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.type_lot);
          dispatch({
            type: DELETE_SUCCESS_TYPES_LOTS,
            payload: typeLotToAdapted(res.type_lot),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_TYPES_LOTS,
            error: err,
          });
        });
    });
  };
}
